<template>
  <v-container
    id="statsModule"
    class="pa-0 mt-0"
    style="height: 100%"
    fill-height
    fluid
    grid-list-xl
  >
    <goodCauseDashboardOverallStats :stats="statistics[0]" />
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import goodCauseDashboardOverallStats from "@/components/stats/GoodCauseStats/goodCauseDashboardOverallStats.vue";

export default {
  components: {
    goodCauseDashboardOverallStats,
  },
  data: () => ({
    data: {},

    //Supplier Intro
    formDataIntro: {},
    sendIntroLoading: false,
  }),
  computed: {
    ...mapGetters({
      user: "user",
      userData: "user/userData",
      statistics: "stats/specificSupplierStats",
    }),
  },
  watch: {},
  mounted() {
    this.$store.dispatch(
      "stats/goodCauseStatsLoadByID",
      this.userData.admin_goodCause_id
    );
  },
  methods: {},
};
</script>
// TODO: Good Cause Resources Link
